import {
  Action_GetListChiNhanh,
  Action_GetListChiNhanhSuccess,
} from "actions/DanhMuc/ChiNhanh/actionTypes";

const initialState = {
  isSaveOk: false,
  objDataChiNhanh: {},
};
////////////////////////
const Reducer_GetListChiNhanh = (state, action) => ({
  ...state,
  isSaveOk: false,
});
const Reducer_GetListChiNhanhSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objDataChiNhanh: action.payload,
  };
};



// end 
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case Action_GetListChiNhanh:
      return Reducer_GetListChiNhanh(state, action);
    case Action_GetListChiNhanhSuccess:
      return Reducer_GetListChiNhanhSuccess(state, action);
    default:
      return state;
  }
};
export default authReducer;
